<template>
  <div id="gallery">
    <div class="row align-center medium-collapse">
      <div class="xxlarge-10 medium-12 columns">
        <masonry
          :cols="{ default: 3, 767: 2 }"
          :gutter="{ default: '40px', 767: '20px' }"
        >
          <div
            v-on:mouseenter="mouseEnter"
            v-on:mouseleave="mouseLeave"
            v-on:click="mouseClick"
            class="gallery-item"
            v-parallax="0.02"
            v-for="(entrie, index) in thisGallery"
            :key="index"
          >
            <span class="video-icon" v-if="entrie.video">
              <svg class="play-icon" viewBox="0 0 240 240">
                <path
                  class="outside"
                  d="M120 3.5C55.7 3.5 3.5 55.7 3.5 120S55.7 236.5 120 236.5 236.5 184.3 236.5 120 184.3 3.5 120 3.5z"
                ></path>
                <path
                  class="inside"
                  d="M94.6 72.8c-1.4.2-2.4 1.4-2.3 2.8v88.8c0 1.5 1.3 2.8 2.8 2.8.5 0 1-.1 1.5-.4l72.1-44.4c1.3-.8 1.7-2.5.9-3.8-.2-.3-.5-.6-.9-.9L96.5 73.2c-.6-.3-1.2-.5-1.9-.4z"
                ></path>
              </svg>
            </span>
            <img
              v-if="entrie.image"
              :data-Id="index"
              :data-mainText="entrie.titulo_principal"
              :data-secText="entrie.titulo_secundario"
              :data-video="entrie.video"
              :data-url="entrie.image.sizes['product-thumb-retina']"
              v-bind:alt="entrie.artista"
              v-lazyload
            />
          </div>
        </masonry>
      </div>
    </div>

    <div class="img-overlay-wrapper">
      <button
        class="close-btn align-center-middle flex-container"
        v-on:click="overlayClick"
      >
        <svg class="close-btn-svg" viewBox="0 0 20 20">
          <path
            d="M18.5 17.9c.4.4.3 1 0 1.3-.4.4-.9.4-1.3 0L10 11.6l-7.2 7.6c-.4.4-.9.4-1.3 0-.3-.3-.4-.9 0-1.3L9 10.1l-7.6-8c-.3-.3-.3-.9 0-1.3.3-.3.9-.3 1.3 0L10 8.6 17.3.8c.4-.3 1-.3 1.3 0 .3.4.3 1 0 1.3l-7.6 8 7.5 7.8z"
          />
        </svg>
      </button>
      <div class="img-wrapper">
        <img
          class="gallery-image"
          v-images-loaded="loaded"
          data-mainText=""
          v-bind:src="imgUrl"
        />
        <!-- <video v-else controls>
          <source v-bind:src="videoUrl" type="video/mp4">
          Your browser does not support the video tag.
        </video> -->

        <div v-if="!hasConsent" class="video-placeholder">
          <p>
            Este vídeo esta bloqueado até que aceite os medias externos nas
            preferências de cookies.
          </p>
          <button @click="openPreferences">Enable videos</button>
        </div>
        <div v-else class="vimeo-player" id="vimeo-player"></div>
        <div class="tec-info">
          <p class="main-info">{{ mainText }}</p>
          <p class="sec-info">{{ secText }}</p>
        </div>
      </div>
      <button
        class="prev-slide align-center-middle flex-container"
        v-on:click="prevSlide"
      >
        <svg class="prev-slide-svg" viewBox="0 0 10 20">
          <path
            d="M9.7 2.1c.3-.3.3-.9 0-1.3-.3-.3-.9-.3-1.3 0L.2 9.5c-.2.2-.2.4-.2.6 0 .3.1.5.2.6l8.1 8.5c.4.4.9.4 1.3 0 .3-.3.4-.9 0-1.3l-7.5-7.8 7.6-8z"
          />
        </svg>
      </button>
      <button
        class="next-slide align-center-middle flex-container"
        v-on:click="nextSlide"
      >
        <svg class="next-slide-svg" viewBox="0 0 10 20">
          <path
            d="M7.9 10.1L.4 17.9c-.4.4-.3 1 0 1.3.4.4.9.4 1.3 0l8.1-8.5c.1-.1.2-.3.2-.6 0-.2 0-.4-.2-.6L1.6.8C1.2.5.6.5.3.8c-.3.4-.3 1 0 1.3l7.6 8z"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import Player from "@vimeo/player";
import imagesLoaded from "vue-images-loaded";

export default {
  name: "gallery",
  data() {
    return {
      slug: -1,
      imgUrl: "",
      mainText: "",
      secText: "",
      videoUrl: null,
      activeId: -1,
      galleryArray: [],
      isOpen: false,
      vimeoPlayer: null,
      loadingImage: false
    };
  },
  directives: {
    imagesLoaded
  },
  methods: {
    openPreferences() {
      window.CookieConsent.showPreferences();
    },
    loaded: function() {
      this.loadingImage = false;
      document.body.style.cursor = "default";

      TweenMax.set([".next-slide", ".prev-slide"], {
        pointerEvents: "auto"
      });
    },
    nextSlide: function() {
      if (this.loadingImage) return;

      this.loadingImage = true;
      document.body.style.cursor = "wait";

      TweenMax.set([".next-slide", ".prev-slide"], {
        pointerEvents: "none"
      });

      this.activeId < this.galleryArray.length - 1
        ? this.activeId++
        : (this.activeId = 0);
      this.activatePhoto(this.galleryArray[this.activeId]);
    },
    prevSlide: function() {
      if (this.loadingImage) return;

      this.loadingImage = true;
      document.body.style.cursor = "wait";

      this.activeId > 0
        ? this.activeId--
        : (this.activeId = this.galleryArray.length - 1);
      this.activatePhoto(this.galleryArray[this.activeId]);
    },
    activatePhoto: function(element) {
      this.mainText = element.titulo_principal;
      this.secText = element.titulo_secundario;
      this.videoUrl = element.video;
      this.activeId = this.activeId;

      document.getElementById("vimeo-player").innerHTML = "";

      if (this.vimeoPlayer)
        this.vimeoPlayer
          .destroy()
          .then(function() {
            // the player was destroyed
          })
          .catch(function(error) {
            // an error occurred
          });

      if (this.videoUrl) {
        this.loadingImage = false;
        document.body.style.cursor = "default";

        TweenMax.set([".next-slide", ".prev-slide"], {
          pointerEvents: "auto"
        });

        this.imgUrl = null;
        TweenMax.set(".img-overlay-wrapper img", {
          display: "none"
        });

        var options = {
          id: this.videoUrl,
          width: Math.round(window.innerWidth * 0.6),
          loop: true
        };

        this.vimeoPlayer = new Player("vimeo-player", options);
      } else {
        this.imgUrl = element.image.url;
        this.videoUrl = null;
      }

      if (this.isOpen && this.imgUrl) {
        TweenMax.set(".img-overlay-wrapper img", {
          scaleX: 1,
          delay: 1
        });
        TweenMax.set(".img-overlay-wrapper img", {
          display: "block"
        });
      }
    },
    overlayClick: function() {
      this.$globalFunctions.disableBodyScroll(false);

      this.videoUrl = null;
      this.activeId = -1;
      this.isOpen = false;
      TweenMax.set(".img-overlay-wrapper", {
        autoAlpha: 0,
        scaleX: 0
      });
      TweenMax.set(".img-overlay-wrapper img", {
        scaleX: 0
      });
      TweenMax.set(".img-overlay-wrapper img", {
        display: "block"
      });
    },
    mouseClick: function(event) {
      this.activeId = event.target.getAttribute("data-Id");
      this.activatePhoto(this.galleryArray[this.activeId]);
      this.$globalFunctions.disableBodyScroll(true);

      //var rgb = this.getAverageRGB(event.target);
      var rgb = {};
      rgb = {
        r: 0,
        g: 0,
        b: 0
      };

      TweenMax.set(".img-overlay-wrapper", {
        //y: window.pageYOffset,
        backgroundColor: "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", .95)",
        autoAlpha: 1
      });

      TweenMax.to(".img-overlay-wrapper", 0.45, {
        scaleX: 1,
        transformOrigin: "center center",
        ease: Expo.easeInOut
      });

      if (!this.videoUrl)
        TweenMax.to(".img-overlay-wrapper img", 0.55, {
          scaleX: 1,
          delay: 0,
          transformOrigin: "center center",
          ease: Expo.easeOut
        });

      console.log(this.galleryArray[this.activeId].video);

      this.isOpen = true;
    },
    mouseLeave: function(event) {
      TweenMax.to(event.target, 1, {
        scale: 1,
        transformOrigin: "center center",
        ease: Expo.easeOut,
        zIndex: 1
      });
    },
    mouseEnter: function(event) {
      TweenMax.to(event.target, 1, {
        scale: 1.1,
        transformOrigin: "center center",
        ease: Expo.easeOut,
        zIndex: 2
      });
    },
    getAverageRGB: function(imgEl) {
      var blockSize = 5, // only visit every 5 pixels
        defaultRGB = { r: 0, g: 0, b: 0 }, // for non-supporting envs
        canvas = document.createElement("canvas"),
        context = canvas.getContext && canvas.getContext("2d"),
        data,
        width,
        height,
        i = -4,
        length,
        rgb = { r: 0, g: 0, b: 0 },
        count = 0;

      if (!context) {
        return defaultRGB;
      }

      height = canvas.height =
        imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height;
      width = canvas.width =
        imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width;

      context.drawImage(imgEl, 0, 0);

      try {
        data = context.getImageData(0, 0, width, height);
      } catch (e) {
        /* security error, img on diff domain */
        return defaultRGB;
      }

      length = data.data.length;

      while ((i += blockSize * 4) < length) {
        ++count;
        rgb.r += data.data[i];
        rgb.g += data.data[i + 1];
        rgb.b += data.data[i + 2];
      }

      // ~~ used to floor values
      rgb.r = ~~(rgb.r / count);
      rgb.g = ~~(rgb.g / count);
      rgb.b = ~~(rgb.b / count);

      return rgb;
    },
    handleKeyup: function(event) {
      if (event.key == "Escape") {
        this.overlayClick();
      }
      if (event.key == "ArrowLeft") {
        this.prevSlide();
      }
      if (event.key == "ArrowRight") {
        this.nextSlide();
      }
    }
  },
  mounted() {
    this.slug = this.$route.params.slug;
    console.log(this.slug);
  },
  created() {
    window.addEventListener("keyup", this.handleKeyup);
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.handleKeyup);
  },
  computed: {
    hasConsent() {
      return this.$hasExternalMediaConsent();
    },
    thisGallery() {
      this.galleryArray = this.$store.getters.getGallery(
        this.$route.params.slug
      );
      console.log(this.galleryArray);
      return this.$store.getters.getGallery(this.$route.params.slug);
    }
  }
};
</script>
<!-- styling for the component -->
<style lang="scss">
#gallery {
  margin: 100px 0;

  > .row {
    position: relative;
    z-index: 0;
  }

  .gallery-item {
    position: relative;
    margin: 40px 0;
    cursor: pointer;

    .video-icon {
      position: absolute;
      top: calc(50% - 25px);
      left: calc(50% - 25px);
      z-index: 1;
      width: 50px;
      opacity: 0.6;

      pointer-events: none;

      .outside {
        fill: black;
      }

      .inside {
        stroke: white;
        stroke-width: 6px;
      }
    }
  }

  .img-overlay-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    background: rgba(0, 0, 0, 0.95);
    text-align: center;

    opacity: 0;
    visibility: hidden;

    z-index: 100;

    -webkit-transform: scaleX(0);
    transform: scaleX(0);

    .img-wrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate3d(-50%, -50%, 0);
      transform: translate3d(-50%, -50%, 0);
    }
    img {
      position: relative;
      max-width: 80vw;
      max-height: 80vh;
      max-height: calc(var(--vh, 1vh) * 80);

      -webkit-transform: scaleX(0);
      transform: scaleX(0);
    }

    video,
    .vimeo-player {
      position: relative;
      max-width: 60vw;
    }

    .close-btn {
      position: absolute;
      top: 0px;
      left: calc(50% - 30px);
      width: 60px;
      height: 60px;
      padding: 0;
      background: transparent;
      border: 0;
      outline: none;
      cursor: pointer;

      .close-btn-svg {
        width: 20px;
        height: 20px;

        transition: transform 0.25s ease-in-out;

        path {
          fill: #ffffff;
        }
      }

      &:hover {
        .close-btn-svg {
          transform: rotate(90deg);
        }
      }
    }

    .prev-slide,
    .next-slide {
      position: absolute;
      width: 60px;
      height: 60px;
      top: calc(50% - 60px);
      left: 10px;
      background: transparent;
      border: none;
      outline: none;
      padding: 0;
      cursor: pointer;

      transition: transform 0.25s ease-in-out;

      svg {
        width: 10px;
        height: 20px;

        path {
          fill: #ffffff;
        }
      }
    }

    .prev-slide {
      &:hover {
        transform: translate3d(-5px, 0, 0);
      }
    }

    .next-slide {
      &:hover {
        transform: translate3d(5px, 0, 0);
      }
    }

    .next-slide {
      left: auto;
      right: 10px;
    }

    .tec-info {
      position: relative;
      margin-top: 10px;
      color: white;

      .main-info {
        @include responsive-font-size(13px);
        font-family: "Libre Baskerville";
        line-height: 1.5em;
        color: white;
        text-transform: initial;
        margin: 0;
      }

      .sec-info {
        @include responsive-font-size(10px);
        color: rgba(255, 255, 255, 0.3);
        margin-top: 3px;
        letter-spacing: 0.25px;
      }
    }
  }
}

body.mobile {
  #gallery {
    .img-overlay-wrapper {
      .close-btn {
        &:hover {
          .close-btn-svg {
            transform: none;
          }
        }
      }

      .next-slide,
      .prev-slide {
        &:hover {
          transform: none;
        }
      }
    }
  }
}

@include max-screen($medium) {
  #gallery {
    padding: 0 60px;
  }
}

@include max-screen($small) {
  #gallery {
    padding: 0 30px;
    margin-top: 0;
    margin-bottom: 60px;

    .img-overlay-wrapper {
      .prev-slide,
      .next-slide {
        left: -5px;
      }

      .next-slide {
        left: auto;
        right: -5px;
      }
    }
  }
}

@include max-screen($xsmall) {
  #gallery {
    padding: 0 20px;

    .gallery-item {
      margin: 20px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blocks/gallery.vue